import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-tabs',
  styleUrls: ['./tabs.component.scss'],
  templateUrl: './tabs.component.html',
})
export class TabsComponent {

  countryName: string = '';
  countryType: string = '';

  constructor(private route: Router) {

    this.countryType = this.route.getCurrentNavigation().extras.state.countryType;
    this.countryName = this.route.getCurrentNavigation().extras.state.countryName;

    console.log(" Tabs information", this.countryType, ' / ', this.countryName);
  }
}
